import {
    StyledDropdownWrapper
} from "../../../admin/components/PartnersAndBuildingsDropdowns/PartnersAndBuildingsDropdowns.styled";

const Input = ({
                   type = 'text',
                   label,
                   name,
                   value,
                   onChange,
                   max,
                   min,
                   autocomplete,
                   onBlur,
                   placeholder,
                   tabIndex,
                   maxLength,
                   inputMode,
                   pattern,
                   borderless = false
               }) => {
    return (
        <StyledDropdownWrapper className='input'>
            <label className='label' htmlFor={name}>{label}</label>
            <input
                type={type}
                className={`form-control js-branch ${borderless ? 'borderless-input-border' : 'bllink-input-border'}`}
                name={name}
                id={name}
                value={value}
                onChange={onChange}
                max={max}
                min={min}
                autoComplete={autocomplete}
                onBlur={onBlur}
                placeholder={placeholder}
                tabIndex={tabIndex}
                maxLength={maxLength}
                inputMode={inputMode}
                pattern={pattern}
            />
        </StyledDropdownWrapper>
    )
}

export default Input;
